import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {Typography,Fab,Toolbar,TextField} from '@material-ui/core';
import FormGroup from '@material-ui/core/FormGroup';
import SendIcon from '@material-ui/icons/Send';
import SearchIcon from '@material-ui/icons/Search';

import Paper from '@material-ui/core/Paper';
import classNames from 'classnames';
import ReactTable from './shares/react_table';

import {styles} from '../layout/theme';
import Utils from '../api/api';


export class SubscribersList extends Component {
  constructor(props){
    super(props);
    this.state = {
      keyword: '',
      searchClick: false
    }
  }
  handleSearch(e){
    var el = document.getElementById('keyword');
    this.setState({ keyword: el.value.trim() });
  }
  handleSendMail(){
    this.context.router.history.push('/campaign/send');
  }
  render(){
    const classes = this.props.classes;
    //console.log(this.state.categories)
    var source = {
      thead: [{title:'Email',value:'email'}],
      tbody: function (n) {
        return ({
          _id: n._id,
          email: n.email,
        })
      }
    };
    return(
      <div className="category-page-list">
        <div className={classNames(classes.auto_toggle, this.state.failed && classes.run)}>
          <Typography type="body2">{this.state.message}</Typography>
        </div>
        <Toolbar className={classes.toolbar}>
          <Typography className={classes.heading} variant="h5">Danh mục cấu hình/tùy chỉnh</Typography>
        </Toolbar>
        <Paper className={classes.paper}>
          <Toolbar className={classes.tableToolbar}>
            <FormGroup className={classes.formRowToolbar}>
              <TextField type="search" id="keyword" label="Tìm kiếm" className={classes.textField + ' form-control-no-bottom'} value={this.state.keyword} onChange={(event)=>this.setState({keyword:event.target.value.trim()})}
              margin="normal"
              InputLabelProps={{
                shrink: true
              }}/>
            </FormGroup>
            <Fab color="primary" aria-label="search" className={classes.button} onClick={(e)=>this.handleSearch(e)}>
              <SearchIcon />
            </Fab>
            <Fab color="primary" aria-label="send" className={classes.button} onClick={()=>this.handleSendMail()}>
              <SendIcon />
            </Fab>
          </Toolbar>
          <ReactTable showCheckBox={true} apiList='subscribers' apiSingle='subscriber' apiTable='subscribers' apiDuplicate={true} router={this.context.router} dataMap={source} showCheckBox={false} keyword={this.state.keyword} isSearch={this.state.searchClick}>
          </ReactTable>
        </Paper>
      </div>
    )
  }
}

SubscribersList.propTypes = {
  classes: PropTypes.object.isRequired,
};
SubscribersList.contextTypes = {
  router: PropTypes.object
};

export default withStyles(styles)(SubscribersList);
